import grnModule from "./grn";

export const grnModules = {
  grn: grnModule,
};
